import en from '@/../i18n/en.json';
import { env } from '@/constants';
import { i18nEscape } from '@/utils/i18n.utils';
import { createI18n, type TranslateResult } from 'vue-i18n';

const locale = localStorage.getItem('viewLocaleKeys') === 'true' && env.VITE_ENV !== 'production' ? '' : 'en';
export const i18n = createI18n({
  silentTranslationWarn: true,
  warnHtmlMessage: false,
  messages: { en: i18nEscape(en) },
  locale: locale,
  fallbackLocale: locale,
  legacy: false,
});

export const defineMessages = <T extends Record<string, string>>(messages: T): { [K in keyof T]: TranslateResult } => {
  const updatedMessages: { [K in keyof T]: TranslateResult } = {} as never;
  for (const message in messages) {
    updatedMessages[message] = i18n.global.t(messages[message]);
  }

  return updatedMessages;
};
